/**
 * Load script async function to execute a callback after finishing script loading
 *
 * @param {url} src The script src url
 * @param {string} id The script id for further identification
 * @param {bool} async default to true
 * @param {string} type The script type
 * @returns Promise
 */

export const loadScript = (src, id, async = true, type = 'text/javascript') => {
	return new Promise((resolve, reject) => {
		try {
			const el = document.createElement('script');
			const container = document.head || document.body;

			el.type = type;
			el.async = async;
			el.id = id;
			el.src = src;

			el.addEventListener('load', () => {
				resolve({ status: true });
			});

			el.addEventListener('error', () => {
				reject({
					status: false,
					mesage: `Failed to load the script ${src}`
				});
			});
			container.appendChild(el);
		} catch (err) {
			reject(err);
		}
	});
};
